import r from "axios";
import { setupRequestInterceptor as t } from "./interceptors/requestInterceptor.js";
import { setupUnauthorizedInterceptor as e } from "./interceptors/unauthorizedInterceptor.js";
import { setupServerErrorInterceptor as o } from "./interceptors/serverErrorInterceptor.js";
const s = (t2, e2 = []) => {
  const o2 = r.create({ baseURL: t2 });
  return e2.forEach((r2) => {
    r2(o2);
  }), o2;
}, p = (r2) => s(r2, [t, e, o]);
export {
  s as initializeHttp,
  p as initializeHttpWithDefaultValues
};
//# sourceMappingURL=http.js.map
